declare var $;

class BookSearchController {
	
	public keyword: string = '';
	public searchedKeyword: string = '';
	public bookID: string;
	
	public pageNumber: number = 1;
	public recordsPerPageOptions = [5, 10, 25];
	public recordsPerPage: number;
	
	public recordsCount: (number|null) = null;
	public totalPages: (number|null) = null;
	public pages: Array<any> = [];
	
	public activePage: any;
	
	public isSearching: boolean = false;
	public hasSearched: boolean = false; 
	
	// @ngInject
	constructor( 
		private $attrs, 
		private bookService,
		private observerService
	) {}

	public $onInit = () => {
		
		this.bookID = this.$attrs.bookId;
		
		this.recordsPerPage = this.recordsPerPageOptions[1];
		
		this.observerService.attach( this.searchPagesByKeyword, 'searchPagesByKeyword' );
	}
	
	public search = ( resetSearchValues = true, usePrevKeyword = false ) => {
		this.searchedKeyword = ( usePrevKeyword ) ? this.searchedKeyword : this.keyword;
		
		if ( !this.searchedKeyword.length ) {
			return;
		}
		
		this.pages = [];
		if ( resetSearchValues ) {
			this.resetSearchValues();
		}
		
		this.isSearching = true;
		
		this.bookService.getPagesForBookByKeyword( this.searchedKeyword, this.bookID, this.pageNumber, this.recordsPerPage )
			.then( result => {
				
				let pages = result.data.data.records;
				this.pages = this.createPageExcerpts( pages, this.searchedKeyword );
				
				this.recordsCount = result.data.data.recordsCount;
				this.totalPages = result.data.data.totalPages;
				
				this.isSearching = false;
				this.hasSearched = true; 
			})
	}
	
	private createPageExcerpts = ( pages: Array<any>, searchTerm: string ): Array<any> => {
		
		pages.forEach( ( page, index ) => {
			let pageText = this.getExcerptByKeyword( page.pageText, searchTerm );
			
			// Search and replace the search term with case-insensitive in mind.
			let regex = new RegExp( searchTerm, 'gi' );
			let matches = pageText.match( regex );
			
			if ( null !== matches ) {
				matches.forEach( match => {
					// Ensure we aren't replacing the same string so only replace if there isn't an html tag before the match.
					let matchRegex = new RegExp( `^${match}|[^>]${match}`, 'g' );
					pageText = pageText.replace( matchRegex, `<strong>${match}</strong>` );
				});
			}
			
			pages[ index ].pageText = pageText;
		})
		
		return pages;
	}
	
	private resetSearchValues = () => {
		this.pageNumber = 1;
		this.recordsCount = null;
		this.totalPages = null;
	}
	
	public nextPage = () => {
		let nextPage = this.pageNumber + 1;
		
		if ( this.totalPages >= nextPage ) {
			this.pageNumber += 1;
			this.search( false, true );
		}
	}
	
	public prevPage = () => {
		let prevPage = this.pageNumber - 1;
		
		if ( 0 !== prevPage ) {
			this.pageNumber -= 1;
			this.search( false, true );
		}
	}

	private getExcerptByKeyword = ( 
		text: string, 
		substring: string, 
		maxLength: number = 100 
	) => {
		
		let strPos = text.toLowerCase().indexOf( substring.toLowerCase() );
		let strLen = text.length;
		let halfMaxLength = maxLength / 2;
		
		// In the first half.
		if ( strLen <= maxLength || strPos < halfMaxLength ) {
			let newText = text.substr( 0, text.lastIndexOf( ' ', maxLength ) );
			
			if ( maxLength < strLen ) {
				newText = `${newText}...`;
			}
			
			return newText;
		}
		
		// In the last half.
		if ( strPos > strLen - halfMaxLength ) {
			let newText = text.substr( -1 * text.lastIndexOf( ' ', maxLength ) );
			newText = newText.substr( newText.indexOf(' ') + 1 );
			newText = `...${newText}`;
			
			return newText;
		}
		
		// In the middle.
		let startPos = strPos - halfMaxLength;
		let endPos = strPos + halfMaxLength;
		let newText = text.substr( startPos, endPos );
		
		newText = newText.substr( 0, newText.lastIndexOf(' ') );
		newText = newText.substr( newText.indexOf(' ') + 1 );
		newText = `...${newText}...`;
		
		return newText;
		
	}
	
	public searchPagesByKeyword = ( keyword: string ) => {
		this.keyword = keyword;
		this.search();
	}
	
	public openPreviewModal = ( page ) => {
		$('#searchPreviewModal').modal();
		this.activePage = page;
	}
	
	public goToPage = ( pageNumber ) => {
		this.observerService.notify( 'goToPage', {pageNumber:pageNumber, searchedKeyword:this.searchedKeyword} )
	}
	
}

export { BookSearchController };